<template>
  <b-card body-class="m-0 p-0" class="mb-4 h-100" border-variant="0">
    <div v-if="isFundraising || isDonation" class="mt-4">
      <MoneyProgressBar
        :fundraising="fundraisingPaidAmount"
        :firstNameGenitive="getChild.first_name_genitive"
        :showValueDescription="showDescription"
      ></MoneyProgressBar>
    </div>
    <div v-else>
      <MoneyProgressBar
        :fundraising="getChild.fundraising"
        class="mt-4"
        :firstNameGenitive="getChild.first_name_genitive"
        :instalmentsValues="instalmentsValues"
        :isInstalments="isInstalments"
        :showValueDescription="!!paymentType"
      >
      </MoneyProgressBar>
    </div>
    <div v-if="isInstalments && !isDonorDataRoute" class="d-block border-top mt-4"></div>
    <b-card-body
      v-if="isInstalments && !isDonorDataRoute"
      class="pt-4 pb-0 mb-0 text-lg text-blue-500"
    >
      <b-card-text
        class="text-center mb-0"
        v-html="$t('form.typeOfSupport.instalmentsValue', instalmentsValuesPLN)"
      >
      </b-card-text>
    </b-card-body>
  </b-card>
</template>

<script>
import MoneyProgressBar from '@/components/widgets/childCard/MoneyProgressBar.vue'

import { SOFT_PAYMENT_LIMIT } from '@/constants/payment'

import { PaymentType } from '@/types'

import { storeToRefs } from 'pinia'
import useTransactionDataStore from '@/stores/transactionData'
import { useFieldValue } from 'vee-validate'

export default {
  name: 'MoneyLabel',
  components: { MoneyProgressBar },
  computed: {
    getChild() {
      return this.$store.getters['child/getChild']
    },
    isFundraising() {
      return this.paymentType === PaymentType.fundraising
    },
    isDonation() {
      return this.paymentType === PaymentType.fundraisingDonate
    },
    isInstalments() {
      return this.paymentType === PaymentType.instalments && this.amount !== null
    },
    selectedAmountText() {
      if (this.amount === -1) {
        return this.otherAmount
      }
      return this.isFundraising || this.isDonation
        ? this.amount || this.otherAmount
        : SOFT_PAYMENT_LIMIT
    },
    fundraisingPaidAmount() {
      return { add_value: this.selectedAmountText * 100 }
    },
    instalmentsValues() {
      return { instalment: this.selectedAmountText / this.amount, value: this.amount * 100 }
    },
    instalmentsValuesPLN() {
      return { instalment: this.selectedAmountText / this.amount, value: this.amount }
    },
    isDonorDataRoute() {
      return this.$route.name === 'FormOfDonorData'
    },
    showDescription() {
      return this.isFundraising || (this.isDonation && this.selectedAmountText != null)
    }
  },
  setup() {
    const transactionDataStore = useTransactionDataStore()
    const otherAmount = useFieldValue('otherAmount')
    const { amount, paymentType } = storeToRefs(transactionDataStore)

    return {
      amount,
      paymentType,
      otherAmount
    }
  }
}
</script>
